import { PropsWithChildren, useState } from "react";
import { ExpanderButton } from "../Shared/ExpanderButton";

export type AccountSecurityCardProps = {
    title: string,
    icon: string,
    buttonkey: string,
    inUse: boolean,
}

export function AccountSecurityCard(props: PropsWithChildren<AccountSecurityCardProps>) {
    const [openState, setOpenState] = useState<boolean>(props.inUse);
    
    return (
        <>
            <div className={`card card-white shadow mt-4`}>
                <div className={`card-header card-header-clicker ${props.inUse ? "collapsed" : ""}`} data-bs-toggle="collapse" onClick={e => {setOpenState(!openState)}} data-bs-target={`#bdyCollapse_${props.buttonkey}`} aria-expanded={`${openState ? "false" : "true"}`} aria-controls={`bdyCollapse_${props.buttonkey}`}>
                    <div className="d-flex justify-content-between align-content-center">
                    <i className={`card-mini-icon ${props.icon}`}></i> 
                        <div className="w-100">{props.title} - <i>{props.inUse ? "In use" : "Not in use"}</i></div>
                        <div className="align-self-end"><ExpanderButton state={openState}/> </div>
                    </div>
                </div>
                <div className={`collapse multi-collapse ${openState ? "" : "show"}`} id={`bdyCollapse_${props.buttonkey}`}>
                    {props.children}
                </div>
            </div>
        </>
    );
}